module.exports = __webpack_public_path__ + "img/Flag_of_Cyprus.6cff1088.svg";